<template>
  <div v-loading="loading">
    <div class="flex justify-end">
      <base-button
        text="New Reference"
        background="bg-darkBlue"
        color="text-white"
        @click="isPriceReferenceModal = true"
      />
    </div>
    <div class="table-wrapper" id="table-wrapper">
      <table class="custom-table responsive-table border-seperate">
        <thead>
          <tr>
            <!-- <th>
              <base-checkbox />
            </th> -->
            <th>REFERENCE NAME</th>
            <th>DEFAULT LOYALTY</th>
            <th>DISCOUNT (%)</th>
            <th class="relative actions">ACTIONS</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="cursor-pointer"
            v-for="(reference, index) in priceReferences"
            :key="index"
          >
            <!-- <td>
              <base-checkbox />
            </td> -->
            <td>{{ reference.referenceName }}</td>
            <td>{{ reference.defaultLoyalty }}</td>
            <td>{{ reference.discount }}</td>

            <td
              class="relative flex justify-center"
              tabindex="-1"
              @blur="selectedRowId = null"
            >
              <span
                @click="
                  selectedRowId
                    ? (selectedRowId = null)
                    : (selectedRowId = index)
                "
                ><vertical-ellipsis
              /></span>
              <action-popup width="w-32" v-if="selectedRowId == index">
                <div>
                  <p class="py-1" @click="editPriceReference(reference)">
                    Edit
                  </p>
                  <p class="py-1" @click="deletePriceReference(index)">
                    Delete
                  </p>
                </div>
              </action-popup>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="!priceReferences.length">
      <empty-table-icon />
      <p class="text-center">No price references</p>
    </div>

    <price-reference-modal
      :show-modal="isPriceReferenceModal"
      @close-modal="isPriceReferenceModal = false"
      @created="getPriceReferences"
      :priceReferences="priceReferences"
      :selectedPriceReference="selectedPriceReference"
    />
  </div>
</template>

<script>
import PriceReferenceModal from "../Modals/PriceReferenceForm";
export default {
  name: "price-preferences",
  components: {
    PriceReferenceModal,
  },
  data() {
    return {
      selectedRowId: null,
      priceReferences: [],
      isPriceReferenceModal: false,
      selectedPriceReference: null,
      loading: false,
    };
  },
  mounted() {
    this.getPriceReferences();
  },
  methods: {
    async getPriceReferences() {
      this.loading = true;
      try {
        const response = await this.$_getPriceReferenceSettings();
        this.logResponse(response);
        this.priceReferences = response.data.message.setting.priceReference;
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    async update() {
      this.loading = true;
      let payload = {
        payload: {
          setting: {
            priceReference: [...this.priceReferences],
          },
        },
      };
      try {
        const response = await this.$_updatePriceReferenceSettings(payload);
        this.logResponse(response);
        this.generateToast("Success!", "success");
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    editPriceReference(reference) {
      this.selectedPriceReference = reference;
      this.isPriceReferenceModal = true;
    },
    deletePriceReference(index) {
      this.generateToast("Deleting", "success");
      this.priceReferences.splice(index, 1);
      this.update();
    },
  },
};
</script>

<style scoped>
td,
th {
  padding: 1rem 2rem;
}
.actions {
  width: 3rem;
}
</style>
